module.exports = __webpack_public_path__ + "img/locationVideo.25a61feb.jpg";